// extracted by mini-css-extract-plugin
module.exports = {"button":"g7UGO"};